export const servicesData = {
    services: [
        {
            serviceId: 1,
            image: "saque_rotativo.jpeg",
            title: "Abertura e Regularização de CNPJ",
            description: "Faça a abertura da sua empresa de forma rápida e sem burocracia, ou mantenha ela regularizada, em dia com com as normas e tributações...",
        },
        {
            serviceId: 2,
            image: "family4.jpeg",
            title: "Gestão Financeira",
            description: "Controle e organização das finanças, incluindo o acompanhamento de receitas e despesas, garantindo saúde do seu negócio e impulsionando o crescimento...",
        },
        {
            serviceId: 3,
            image: "emprestimo_consignado.jpeg",
            title: "Imposto de Renda PF/PJ",
            description: "Ajudamos você a fazer sua declaração anual do imposto de renda de maneira adequada para você não perder tempo e evitar multas e impostos indevidos...",
        },
        {
            serviceId: 3,
            image: "pix_parcelado.jpeg",
            title: "Perícia Judicial - Cálculos Contábeis",
            description: "Análise e elaboração de cálculos contábeis em processos judiciais com precisão e confiabilidade, auxiliando na resolução de disputas de forma clara e objetiva.",
        },
        {
            serviceId: 3,
            image: "operaria.jpeg",
            title: "Sistema PDV Declarei",
            description: "Gerencie suas vendas, cadastre fornecedores, produtos e serviços em um sistema ágil e intuitivo. Um PDV completo para sua empresa, disponível diretamente pelo navegador.",
        },
        {
            serviceId: 3,
            image: "cozinheiro.jpeg",
            title: "Emissão de Notas",
            description: "Emissão de notas fiscais de forma rápida, segura e totalmente digital, garantindo a conformidade fiscal e aumentando a credibilidade do seu negócio...",
        },
    ],
};
